/**
 * Random Code Generator — shared utility for generating random alphanumeric codes.
 *
 * Used by both link codes (auth.ts) and join codes (classrooms.ts).
 * Uses an unambiguous character set (no 0/O/1/I/L confusion).
 *
 * Extracted from auth.ts generateLinkCode() and classrooms.ts generateJoinCode() (D-SCAN-2 D2-2).
 */

/** Unambiguous alphanumeric characters (no 0/O, 1/I/L) */
export const UNAMBIGUOUS_CHARSET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'

/**
 * Generate a random code of the given length using the unambiguous charset.
 * Uses crypto.getRandomValues() for unpredictable output (FS-1, SEC-3).
 */
export function generateRandomCode(
  length: number = 6,
  charset: string = UNAMBIGUOUS_CHARSET,
): string {
  const randomValues = new Uint32Array(length)
  crypto.getRandomValues(randomValues)
  let code = ''
  for (let i = 0; i < length; i++) {
    code += charset.charAt(randomValues[i] % charset.length)
  }
  return code
}
